import { ThemeEnum } from '../enums'

/**Установка rem размера */
export const SetSize = (size: Number) => {
  document.documentElement.style.fontSize = `${size}px`
}

/**Установка темы */
export const SetTheme = (theme: ThemeEnum) => {
  switch (theme) {
    case ThemeEnum.Light:
      SetLightTheme()
      break
    case ThemeEnum.Dark:
      SetDarkTheme()
      break
    case ThemeEnum.System:
      const isDark = window?.matchMedia?.(
        '(prefers-color-scheme: dark)'
      ).matches
      if (isDark) SetDarkTheme()
      else SetLightTheme()
      break
  }
}
/**Установка темной темы */
const SetDarkTheme = () => {
  document.documentElement.classList.add('dark-theme')
}
/**Установка светлой темы */
const SetLightTheme = () => {
  document.documentElement.classList.remove('dark-theme')
}
